import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/plat/admin/giftCode/';

function baseApi() {

    function insert(data) {
        return Post(baseUrl + 'insertGiftCode', data);
    }
    function deleteData(data) {
        return Post(baseUrl + 'deleteGiftCode', data);
    }
    function update(data) {
        return Post(baseUrl + 'updateGiftCode', data);
    }
    function query(data) {
        return Post(baseUrl + 'queryGiftCode', data);
    }

    function queryCount(data) {
        return Post(baseUrl + 'count', data);
    }

    return {
        insert, deleteData, update, query, queryCount
    };
}

export const giftCodeApi = baseApi();
